import React from "react"
import { useFormikWizard } from "formik-wizard"
import steps from "./steps"
const checkProperties = (obj) => {
  for (let key in obj) {
    if (obj[key] !== null && obj[key] !== "") return false
  }
  return true
}

const Nav = ({ currentStep, wizard }) => {
  const context = useFormikWizard()

  const checkStepName = () => {
    if (currentStep === "business_info") {
      return "Business Information"
    } else {
      return "Other Stakeholders Information"
    }
  }

  const checkStepId = () => {
    if (currentStep === "business_info") {
      return 1
    } else if (currentStep === "other_info") {
      return 2
    } else {
      return 3
    }
  }
  

  return (
    <div className="container">
      <div className="row px-lg-5">
        <div className="business-title-step_wrapper pt-5 pb-2 border-bottom">
          <h4 className="current-step text-sm-center">{checkStepName()}</h4>
          <div className="tag">
            <span>
              {checkStepId()} of {steps.length}
            </span>
          </div>
        </div>
      </div>
    </div>

    // <div className="container">
    //   <div className="row">
    //     <div
    //       className={
    //         currentStep === "business_info"
    //           ? "contained col-lg-4"
    //           : "text col-lg-4"
    //       }
    //     >
    //       <button
    //         onClick={() => {
    //           wizard.push("business_info")
    //         }}
    //         className="btn"
    //       >
    //         Business Information
    //       </button>
    //     </div>

    //     <div
    //       className={
    //         currentStep === "other_info"
    //           ? "contained col-lg-4"
    //           : "text col-lg-4"
    //       }
    //     >
    //       <button
    //         onClick={() => {
    //           if (checkProperties(context.values.business_info)) {
    //             wizard.push("business_info")
    //           } else {
    //             wizard.push("other_info")
    //           }
    //         }}
    //         className="btn"
    //       >
    //         Other Information
    //       </button>
    //     </div>

    //     <div
    //       className={
    //         currentStep === "additional_documents"
    //           ? "contained col-lg-4"
    //           : "text col-lg-4"
    //       }
    //     >
    //       <button
    //         onClick={() => {
    //           if (checkProperties(context.values.business_info)) {
    //             wizard.push("business_info")
    //           } else if (checkProperties(context.values.other_info)) {
    //             wizard.push("other_info")
    //           } else {
    //             wizard.push("additional_documents")
    //           }
    //         }}
    //         className="btn"
    //       >
    //         Additional Documents
    //       </button>
    //     </div>
    //   </div>
    // </div>
  )
}

export default Nav
